import { INVENTORY_CATALOG } from './inventory';

interface InventoryPanelProps {
  inventory: string[];
}

export function InventoryPanel({ inventory }: InventoryPanelProps) {
  if (inventory.length === 0) return null;

  return (
    <div className="escape-inventory">
      <p className="escape-inventory__label">
        <i className="fa-solid fa-bag-shopping" aria-hidden="true" /> Inventory
      </p>
      <ul className="escape-inventory__list" aria-label="Collected items">
        {inventory.map(id => {
          const item = INVENTORY_CATALOG[id];
          if (!item) return null;
          return (
            <li key={id} className="escape-inventory__item" title={item.description}>
              <i className={`fa-solid fa-${item.icon}`} aria-hidden="true" />
              <span>{item.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
